import { createWebHashHistory, createWebHistory, createRouter } from "vue-router";

const routes = [{
  path: "/",
  name: "Home",
  component: () =>
    import('@/views/HomeView.vue'),
  meta: {
    title: `数据星图 - 首页`
  }
},
{
  path: "/About",
  name: "About",
  component: () =>
    import('@/views/AboutView.vue'),
  meta: {
    title: `数据星图 - 关于`
  }
},
{
  path: "/CatalogTotal",
  name: "CatalogTotal",
  component: () =>
    import('@/views/CatalogTotalView.vue'),
  meta: {
    title: `数据星图 - 目录`
  }
},
{
  path: "/Catalog/",
  name: "Catalog",
  component: () =>
    import('@/views/CatalogView.vue'),
  meta: {
    title: `数据星图 - 目录`
  }
},
{
  path: "/Data/",
  name: "Data",
  component: () =>
    import('@/views/DataView.vue'),
  meta: {
    title: `数据星图 - 数据`
  }
},
{
  path: "/Search/",
  name: "Search",
  component: () =>
    import('@/views/SearchView.vue'),
  meta: {
    title: `数据星图 - 搜索`
  }
},
{
  path: "/Graph/",
  name: "Graph",
  component: () =>
    import('@/views/GraphView.vue'),
  meta: {
    title: `数据星图 - 星图`
  }
},
{
  path: "/GraphHelp",
  name: "GraphHelp",
  component: () =>
    import('@/views/GraphHelpView.vue'),
  meta: {
    title: `数据星图 - 星图`
  }
},
{
  path: "/Chat",
  name: "Chat",
  component: () =>
    import('@/views/ChatView.vue'),
  meta: {
    title: `数据星图 - 问答`
  }
},
];

console.log(process.env.NODE_ENV);
console.log(process.env.SUBDIR);
const router = createRouter({
  // https://next.router.vuejs.org/guide/essentials/history-mode.html
  history:
    process.env.NODE_ENV === 'production' ? createWebHistory('/opendata/') :
      createWebHashHistory(),
  routes,
});

export default router;